<div class="survey-notification-box">
  <div>
    <h4>{{ superhuman.title }}</h4>
    <p class="xs-hide sm-hide">{{ superhuman.body }}</p>
  </div>
  <div class="ui-button-group">
    <button
      routerLink="/survey"
      (click)="
        surveyNotStarted
          ? trackCTA('Superhuman Survey: [Button] Started first time')
          : trackCTA('Superhuman Survey: [Button] Started again')
      "
      class="ui-button"
    >
      {{ (surveyNotStarted ? 'survey.performance.cta' : 'survey.performance.finish') | translate }}
    </button>
    <button (click)="ignoreSurvey()" class="ui-button-text">{{ 'survey.performance.no' | translate }}</button>
  </div>
</div>
